import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
// import App from './App';
import { WebcallProvider } from "./V2.0/Context/WebcallContext";

import App from "./V2.0/App";

function importBuildTarget() {
  // DefinePlugin in webpack.config.js will substitute
  // process.env.REACT_APP_BUILD_TARGET with it's value at build time.
  // https://webpack.js.org/plugins/define-plugin/

  // TerserPlugin in webpack.config.js will eliminate dead code
  // ...if we make it easy enough (no maps or switches, etc).
  // https://webpack.js.org/plugins/terser-webpack-plugin/

  if (process.env.REACT_APP_BUILD_TARGET === "app") {
    return import("./V2.0/App.js");
  } else if (process.env.REACT_APP_BUILD_TARGET === "mobile") {
    return import("./V2.0/Mobile.js");
  } else {
    return Promise.reject(
      new Error("No such build target: " + process.env.REACT_APP_BUILD_TARGET)
    );
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
importBuildTarget().then(({ default: Environment }) => {
  root.render(
    // <React.StrictMode>
    <Router>
      <WebcallProvider>
        <Environment />
      </WebcallProvider>
    </Router>
    // </React.StrictMode>
  );
});
